import React from 'react';
import { logoImg } from '../../../assets/images';
import { productCategoryOptions } from '../../../utils/appConstants';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { productExtraAction } from '../../../store/actions/ProductActions';

const Footer = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const categories = productCategoryOptions?.slice(0, 4);
  const userShopFilters = useSelector(state => state?.products?.userShopFilters);

  function handleShopClick(option) {
    const prevShopFilters = userShopFilters ?? {};
    dispatch(productExtraAction('userShopFilters', { ...prevShopFilters, category: option }));
    navigate('/shop');
  }

  return (
    <div>
      <div className='bg-dark-two dark-footer'>
        <div className='footer-section'>
          <div className='footer-widget-section'>
            <div className='container custom-container'>
              <div className='row gy-6'>
                <div className='col-md-4'>
                  <div className='footer-widget'>
                    <div className='footer-widget__logo'>
                      {/* <a className='logo-dark' href='index.html'>
                        <img src={logoImg} alt='Logo' />
                      </a> */}
                      <a style={{}} href='index.html'>
                        <img
                          src={logoImg}
                          alt='Logo'
                          style={{ width: 100, borderRadius: '100%', translate: 'scale(1.3)' }}
                        />
                      </a>
                    </div>
                    <div className='footer-widget__social'>
                      <a href='https://www.facebook.com/share/1EyHKLPMqQ/?mibextid=LQQJ4d'>
                        <i className='lastudioicon-b-facebook'></i>
                      </a>
                      <a href='https://www.instagram.com/saycheezecakes/profilecard/?igsh=MWRkMzJvM2M0OG5xYw=='>
                        <i className='lastudioicon-b-instagram'></i>
                      </a>
                      <a href='https://wa.me/919945423080'>
                        <i className='lastudioicon-b-whatsapp'></i>
                      </a>
                    </div>
                  </div>
                </div>
                <div className='col-md-8'>
                  <div className='footer-widget-wrapper d-flex flex-wrap gap-4'>
                    <div className='footer-widget flex-grow-1'>
                      <h4 className='footer-widget__title'>Categories</h4>

                      <ul className='footer-widget__link'>
                        {categories?.map((option, i) => (
                          <li key={i}>
                            <a href='#' onClick={() => handleShopClick(option)}>
                              {option}
                            </a>
                          </li>
                        ))}
                      </ul>
                    </div>

                    <div className='footer-widget flex-grow-1'>
                      <h4 className='footer-widget__title'>Services</h4>

                      <ul className='footer-widget__link'>
                        <li>
                          <Link to='/termsAndCondition'>Terms And Condition</Link>
                        </li>
                        <li>
                          <Link to='/privacyPolicy'>Privacy Policy</Link>
                        </li>

                        <li>
                          <Link to='/cancellationsAndRefunds'>Cancellations And Refunds</Link>
                        </li>
                        <li>
                          <Link to='/shipping'>Shipping and Delivery</Link>
                        </li>
                      </ul>
                    </div>

                    <div className='footer-widget flex-grow-1'>
                      <h4 className='footer-widget__title'>Information</h4>

                      <ul className='footer-widget__link'>
                        <li>
                          <Link to='/about'>About Us</Link>
                        </li>
                        <li>
                          <Link to='/contact'>Contact Us</Link>
                        </li>
                        <li>
                          <Link to='/shop'>Shop</Link>
                        </li>
                        {/* <li>
                          <a href='about.html'>Selling Tips</a>
                        </li> */}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className='footer-copyright footer-copyright-two'>
            <div className='container'>
              <div className='footer-copyright-text text-center'>
                <p>
                  &copy; 2024 <strong> Saycheeze Cakes </strong> Made with{' '}
                  <i className='lastudioicon-heart-1'></i> by <a href='#'>VisionRealistic</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
